import { Box, VStack } from 'native-base';
import React from 'react';
import { useGiftCardStyles } from '~/shared/styles';
import { observer, GIFTCARD_FLOWS, useSpringBigStore } from '@springbig/shared';
import { Caption } from '~/shared/Typography';
import Pressable from '~/shared/Pressable';

const NoCards = ({
    setIsSetNameModalOpen,
    setOnSubmitAction
}: {
    setIsSetNameModalOpen: (value: boolean) => void
    setOnSubmitAction: (value: GIFTCARD_FLOWS | undefined) => void
}) => {

    const { member, merchant } = useSpringBigStore();
    const {
        empty_card_color,
        empty_card_text_color
    } = useGiftCardStyles();

    const onAddCashFunds = () => {

        if (!member?.first_name || !member?.last_name || !member.confirmed_identity) {
            setIsSetNameModalOpen(true);
            setOnSubmitAction(GIFTCARD_FLOWS.addGiftCard);
        }
        else {
            observer.emit('open-actionsheet', GIFTCARD_FLOWS.addGiftCard);
        }
    };

    return (
        <VStack justifyContent='space-between' flexGrow={1}>
            <Box
                borderStyle='dashed'
                borderWidth={2}
                borderColor={empty_card_color}
                display='flex'
                justifyContent='center'
                alignSelf={'center'}
                width='90%'
                height={170}
                borderRadius={8}
                m={5}
            >
                <Caption
                    alignSelf={'center'}
                    fontSize={20}
                    text='giftCard.addCash'
                    color={empty_card_text_color}
                />
            </Box>
            {
                merchant &&
                !merchant.hide_gift_card_payments &&
                !merchant.gift_cards_purchase_disabled &&
                <Pressable onPress={onAddCashFunds}>
                    <Caption
                        fontSize={22}
                        alignSelf='center'
                        p={4}
                        text='giftCard.addCash'
                        color={empty_card_text_color}
                    />
                </Pressable>
            }
        </VStack>
    );
};

export default NoCards;
